import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ContentPanel from '../ContentPanel';
import cx from 'classnames';
import s from './SlidingPanel.css';


class SlidingPanel extends Component {
  static propTypes = {
    isCollapsed: PropTypes.bool,
  }

  static defaultProps = {
    isCollapsed: true,
  }

  constructor(props) {
    super(props);

    this.state = {
      expanded: null,
      windowWidth: null,
    };

    this.isUnmounted = false;
  }

  componentWillMount() {
    this.setState({
      expanded: !this.props.isCollapsed,
      windowWidth: window.innerWidth,
    });
  }

  componentWillUnmount() {
    this.isUnmounted = true;
  }

  // @TODO figure out how this would be triggered by a prop for messages/LandingPage
  // handleResize = () => {
  //   const windowWidth = this.state.windowWidth;
  //   const mobileContentPanelOpen = this.state.expanded;
  //   const isDesktop = (windowWidth >= 768 && mobileContentPanelOpen);
  //
  //   if (!this.isUnmounted) {
  //     let updatedState = { windowWidth: window.innerWidth };
  //     if (isDesktop) {
  //       updatedState.expanded = !mobileContentPanelOpen;
  //     }
  //
  //     this.setState(updatedState);
  //   }
  // }

  render() {
    const contentPanelIsOpen  = this.props.isCollapsed;
    const contentPanelStyle = (contentPanelIsOpen  ? s.isActive : '');

    return (
      <ContentPanel
        className={cx(s.slidingContentPanel, contentPanelStyle)}
      >
        {this.props.children}
      </ContentPanel>
    );
  }
}

export default SlidingPanel;



// WEBPACK FOOTER //
// ./src/components/SlidingPanel/SlidingPanel.js